/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Booking_Remaining_AfterInputs */

const en_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· ${i?.n} will remain after this booking`)
};

const es_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· te quedarán ${i?.n} sesiones después de esta reserva`)
};

const de_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· nach dieser Buchung verbleiben ${i?.n}`)
};

const zh_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· 本次预订后还剩 ${i?.n} 节`)
};

const ar_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· سيتبقى ${i?.n} بعد هذا الحجز`)
};

const fr_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· il vous restera ${i?.n} séance(s) après cette réservation`)
};

const vi_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· còn ${i?.n} buổi sau lần đặt này`)
};

const sw_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· ${i?.n} vitabaki baada ya nafasi hii`)
};

const th_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· หลังการจองนี้จะเหลืออีก ${i?.n} ครั้ง`)
};

const bs_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· nakon ove rezervacije ostat će ${i?.n} sesija`)
};

const ja_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`・この予約後、残り${i?.n}回`)
};

const ko_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· 이번 예약 후 ${i?.n}회 남음`)
};

const pt_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· restarão ${i?.n} depois desta reserva`)
};

const it_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· dopo questa prenotazione ne rimarranno ${i?.n}`)
};

const sv_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· ${i?.n} återstår efter den här bokningen`)
};

const nl_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· hierna heb je nog ${i?.n} over`)
};

const da_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· der er ${i?.n} tilbage efter denne booking`)
};

const nb_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· ${i?.n} gjenstår etter denne bestillingen`)
};

const fi_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· tämän varauksen jälkeen jäljellä ${i?.n}`)
};

const pl_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· po tej rezerwacji pozostanie: ${i?.n}`)
};

const ru_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· после этого бронирования останется ${i?.n}`)
};

const tr_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· bu rezervasyondan sonra ${i?.n} ders kalacak`)
};

const hi_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· इस बुकिंग के बाद ${i?.n} बचेंगे`)
};

const id_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· tersisa ${i?.n} setelah pemesanan ini`)
};

const ms_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· ${i?.n} akan berbaki selepas tempahan ini`)
};

const cs_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· po této rezervaci zbude ${i?.n}`)
};

const el_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· μετά από αυτή την κράτηση θα απομείνουν ${i?.n}`)
};

const he_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· לאחר ההזמנה יישארו ${i?.n}`)
};

const af_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· ${i?.n} sal ná hierdie bespreking oorbly`)
};

const hu_booking_remaining_after = /** @type {(inputs: Booking_Remaining_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· a foglalás után ${i?.n} alkalom marad`)
};

/**
* | output |
* | --- |
* | "· {n} will remain after this booking" |
*
* @param {Booking_Remaining_AfterInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_remaining_after = /** @type {((inputs: Booking_Remaining_AfterInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Remaining_AfterInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_remaining_after(inputs)
	if (locale === "de") return de_booking_remaining_after(inputs)
	if (locale === "zh") return zh_booking_remaining_after(inputs)
	if (locale === "ar") return ar_booking_remaining_after(inputs)
	if (locale === "fr") return fr_booking_remaining_after(inputs)
	if (locale === "vi") return vi_booking_remaining_after(inputs)
	if (locale === "sw") return sw_booking_remaining_after(inputs)
	if (locale === "th") return th_booking_remaining_after(inputs)
	if (locale === "bs") return bs_booking_remaining_after(inputs)
	if (locale === "ja") return ja_booking_remaining_after(inputs)
	if (locale === "ko") return ko_booking_remaining_after(inputs)
	if (locale === "pt") return pt_booking_remaining_after(inputs)
	if (locale === "it") return it_booking_remaining_after(inputs)
	if (locale === "sv") return sv_booking_remaining_after(inputs)
	if (locale === "nl") return nl_booking_remaining_after(inputs)
	if (locale === "da") return da_booking_remaining_after(inputs)
	if (locale === "nb") return nb_booking_remaining_after(inputs)
	if (locale === "fi") return fi_booking_remaining_after(inputs)
	if (locale === "pl") return pl_booking_remaining_after(inputs)
	if (locale === "ru") return ru_booking_remaining_after(inputs)
	if (locale === "tr") return tr_booking_remaining_after(inputs)
	if (locale === "hi") return hi_booking_remaining_after(inputs)
	if (locale === "id") return id_booking_remaining_after(inputs)
	if (locale === "ms") return ms_booking_remaining_after(inputs)
	if (locale === "cs") return cs_booking_remaining_after(inputs)
	if (locale === "el") return el_booking_remaining_after(inputs)
	if (locale === "he") return he_booking_remaining_after(inputs)
	if (locale === "af") return af_booking_remaining_after(inputs)
	if (locale === "hu") return hu_booking_remaining_after(inputs)
	return en_booking_remaining_after(inputs)
});